import { Injectable } from '@angular/core';
import { Circle, Point, Polygon } from 'ol/geom';
import { Subject } from 'rxjs';
import { DrawToolGeometryInterface } from 'src/app/modelli/inwit/analisi/analysis.interface';
import { AnalysisQueryPointInterface } from 'src/app/modelli/inwit/analisi/query.interface';

export type AnalysisGeometry = Point | Circle | Polygon | null;

export type analysisQueryPointsSourceI = {
  query: AnalysisQueryPointInterface[];
  action: 'add' | 'update' | 'remove' | 'fit' | 'removeAll' | 'removeKML';
  props?: {
    tooltipTextColumn?: string;
    tooltipColor?: string;
    pointStyle?: string;
  };
};

@Injectable({
  providedIn: 'root',
})
export class AnalysisDataLoaderService {
  // Observable sources, ...AnalysisGeometry
  private analysisGeometrySource = new Subject<AnalysisGeometry>(); // one
  private analysisGeometriesSource = new Subject<AnalysisGeometry[]>(); // many
  private drawToolPointSource = new Subject<DrawToolGeometryInterface>();
  private analysisQueryPointsSource = new Subject<analysisQueryPointsSourceI>();

  // Observable streams
  analysisGeometry$ = this.analysisGeometrySource.asObservable(); // one
  analysisGeometries$ = this.analysisGeometriesSource.asObservable(); // many
  drawToolPoint$ = this.drawToolPointSource.asObservable();
  analysisQueryPoints$ = this.analysisQueryPointsSource.asObservable();

  // Service commands
  broadcastAnalysisGeometry(geometry: AnalysisGeometry) {
    this.analysisGeometrySource.next(geometry);
  }

  drawAnalysisGeometries(geometries: AnalysisGeometry[]){
    this.analysisGeometriesSource.next(geometries);
  }

  broadcastDrawToolGeometry(drawToolObj: DrawToolGeometryInterface) {
    // console.log('++++++++++++broadcastGeometryFromDrawTool', drawToolObj);
    this.drawToolPointSource.next(drawToolObj);
  }
  broadcastAnalysisQueryPoints(analysisQueryPoints: analysisQueryPointsSourceI) {
    // console.log('++++++++++++broadcastAnalysisQueryPoints', analysisQueryPoints);
    this.analysisQueryPointsSource.next(analysisQueryPoints);
  }

  constructor() {}
}
